import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative bg-white border border-gray-200 dark:border-gray-700 dark:bg-black rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_3 = { class: "sticky top-0 bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10" }
const _hoisted_4 = { class: "px-6 py-6 bg-white dark:bg-black" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_7 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_8 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_9 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_10 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_11 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_12 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_13 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_14 = { class: "mt-1 text-gray-900 dark:text-white font-medium font-mono" }
const _hoisted_15 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_16 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_17 = { class: "bg-gray-50 dark:bg-black rounded-lg border border-gray-100 dark:border-gray-800 p-2" }
const _hoisted_18 = { class: "mt-1 text-gray-900 dark:text-white font-medium" }
const _hoisted_19 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_20 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_21 = { class: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "absolute top-2 left-2 bg-black/70 text-white px-2 py-1 rounded text-xs font-semibold uppercase" }
const _hoisted_25 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_26 = { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }
const _hoisted_27 = { class: "space-y-3" }
const _hoisted_28 = { class: "grid grid-cols-2 gap-3 text-sm" }
const _hoisted_29 = { class: "ml-2 text-gray-900 dark:text-white font-medium" }
const _hoisted_30 = { class: "ml-2 text-gray-900 dark:text-white font-medium" }
const _hoisted_31 = { class: "ml-2 text-gray-900 dark:text-white font-medium" }
const _hoisted_32 = { class: "ml-2 text-gray-900 dark:text-white font-medium" }
const _hoisted_33 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_34 = { class: "sticky bottom-0 bg-gray-50 dark:bg-black border-t border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-end space-x-3" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = { class: "text-center mt-4 text-white" }

import { ref } from 'vue';
import { useBrand } from '@/composables/brand/useBrand';
import type { Vehicle } from '@/types/vehicle';


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewVehicleModal',
  props: {
    isOpen: { type: Boolean },
    vehicle: {}
  },
  emits: ["close", "edit"],
  setup(__props: any) {

const { brandColors } = useBrand();

const props = __props;



// Lightbox state
const lightboxOpen = ref(false);
const currentPhotoIndex = ref(0);

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

function getPhotoUrl(path: string): string {
  const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000';
  // Below is for local
  // const baseUrl = process.env.VUE_APP_API_URL?.replace('/api', '') || 'http://localhost:8000';
  return `${baseUrl}/storage/${path}`;
}

function openLightbox(index: number) {
  currentPhotoIndex.value = index;
  lightboxOpen.value = true;
}

function closeLightbox() {
  lightboxOpen.value = false;
}

function nextPhoto() {
  if (props.vehicle?.vehicle_photos) {
    currentPhotoIndex.value = (currentPhotoIndex.value + 1) % props.vehicle.vehicle_photos.length;
  }
}

function previousPhoto() {
  if (props.vehicle?.vehicle_photos) {
    currentPhotoIndex.value = currentPhotoIndex.value === 0
      ? props.vehicle.vehicle_photos.length - 1
      : currentPhotoIndex.value - 1;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.vehicle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center mr-3" }, [
                        _createElementVNode("svg", {
                          class: "h-5 w-5 text-blue-600 dark:text-blue-400",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                          }),
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                          })
                        ])
                      ]),
                      _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Vehicle Details ")
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                      class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                    }, _cache[5] || (_cache[5] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white flex items-center mb-4" }, [
                        _createElementVNode("svg", {
                          class: "w-5 h-5 mr-2 text-blue-600 dark:text-blue-400",
                          fill: "currentColor",
                          viewBox: "0 0 20 20"
                        }, [
                          _createElementVNode("path", { d: "M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }),
                          _createElementVNode("path", { d: "M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" })
                        ]),
                        _createTextVNode(" Vehicle Information ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400" }, " Vehicle Make ", -1)),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.vehicle.vehicle_make), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400" }, " Vehicle Model ", -1)),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.vehicle.vehicle_model), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400" }, " Year ", -1)),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.vehicle.vehicle_year), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400" }, " Plate Number ", -1)),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.vehicle.plate_number), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400" }, " Registered Tires ", -1)),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.vehicle.tires_count || 0) + " " + _toDisplayString(_ctx.vehicle.tires_count === 1 ? 'Tire' : 'Tires'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400" }, " Date Added ", -1)),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(formatDate(_ctx.vehicle.created_at)), 1)
                        ])
                      ])
                    ]),
                    (_ctx.vehicle.vehicle_photos && _ctx.vehicle.vehicle_photos.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createElementVNode("h3", _hoisted_20, [
                            _cache[14] || (_cache[14] = _createElementVNode("svg", {
                              class: "w-5 h-5 mr-2 text-blue-600 dark:text-blue-400",
                              fill: "currentColor",
                              viewBox: "0 0 20 20"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z",
                                "clip-rule": "evenodd"
                              })
                            ], -1)),
                            _createTextVNode(" Vehicle Photos (" + _toDisplayString(_ctx.vehicle.vehicle_photos.length) + ") ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicle.vehicle_photos, (photo, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: photo.vehicle_photo_id,
                                onClick: ($event: any) => (openLightbox(index)),
                                class: "relative group cursor-pointer overflow-hidden rounded-lg border-2 border-gray-200 dark:border-gray-600 hover:border-blue-500 dark:hover:border-blue-400 transition-all duration-200"
                              }, [
                                _createElementVNode("img", {
                                  src: getPhotoUrl(photo.photo_path),
                                  alt: `Vehicle photo ${index + 1}`,
                                  class: "w-full h-32 object-cover group-hover:scale-110 transition-transform duration-200"
                                }, null, 8, _hoisted_23),
                                _createElementVNode("div", _hoisted_24, _toDisplayString(photo.photo_side || `Photo ${index + 1}`), 1),
                                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-opacity duration-200 flex items-center justify-center" }, [
                                  _createElementVNode("svg", {
                                    class: "w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                                    })
                                  ])
                                ], -1))
                              ], 8, _hoisted_22))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.vehicle.tires && _ctx.vehicle.tires.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("h3", _hoisted_26, [
                            _cache[16] || (_cache[16] = _createElementVNode("svg", {
                              class: "w-5 h-5 mr-2 text-blue-600 dark:text-blue-400",
                              fill: "currentColor",
                              viewBox: "0 0 20 20"
                            }, [
                              _createElementVNode("path", { d: "M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" })
                            ], -1)),
                            _createTextVNode(" Registered Tires (" + _toDisplayString(_ctx.vehicle.tires.length) + ") ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicle.tires, (tire) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: tire.tire_id,
                                class: "bg-gray-50 dark:bg-black rounded-lg p-4"
                              }, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", null, [
                                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Shop:", -1)),
                                    _createElementVNode("span", _hoisted_29, _toDisplayString(tire.shop), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Code:", -1)),
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(tire.code), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Invoice:", -1)),
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(tire.invoice_number), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Quantity:", -1)),
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(tire.number_of_purchased), 1)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_ctx.vehicle.tires_count === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[21] || (_cache[21] = [
                            _createElementVNode("div", { class: "text-center py-8 text-gray-500 dark:text-gray-400" }, [
                              _createElementVNode("svg", {
                                class: "mx-auto h-12 w-12 text-gray-400 mb-3",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                                })
                              ]),
                              _createElementVNode("p", null, "No tires registered for this vehicle yet.")
                            ], -1)
                          ])))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                      class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 font-medium"
                    }, " Close "),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('edit', _ctx.vehicle))),
                      class: "px-4 py-2 text-white rounded-lg transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
                      style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                    }, " Edit Vehicle ", 4)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "lightbox" }, {
      default: _withCtx(() => [
        (lightboxOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[60] bg-black bg-opacity-90 flex items-center justify-center",
              onClick: closeLightbox
            }, [
              _createElementVNode("button", {
                onClick: closeLightbox,
                class: "absolute top-4 right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
              }, _cache[23] || (_cache[23] = [
                _createElementVNode("svg", {
                  class: "w-8 h-8",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ])),
              (_ctx.vehicle && _ctx.vehicle.vehicle_photos && _ctx.vehicle.vehicle_photos.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _withModifiers(previousPhoto, ["stop"]),
                    class: "absolute left-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                  }, _cache[24] || (_cache[24] = [
                    _createElementVNode("svg", {
                      class: "w-10 h-10",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M15 19l-7-7 7-7"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "max-w-7xl max-h-[90vh] p-4",
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
              }, [
                (_ctx.vehicle && _ctx.vehicle.vehicle_photos && _ctx.vehicle.vehicle_photos[currentPhotoIndex.value])
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: getPhotoUrl(_ctx.vehicle.vehicle_photos[currentPhotoIndex.value].photo_path),
                      alt: `Vehicle photo ${currentPhotoIndex.value + 1}`,
                      class: "max-w-full max-h-[85vh] object-contain rounded-lg"
                    }, null, 8, _hoisted_35))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_36, " Photo " + _toDisplayString(currentPhotoIndex.value + 1) + " of " + _toDisplayString(_ctx.vehicle?.vehicle_photos?.length || 0), 1)
              ]),
              (_ctx.vehicle && _ctx.vehicle.vehicle_photos && _ctx.vehicle.vehicle_photos.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _withModifiers(nextPhoto, ["stop"]),
                    class: "absolute right-4 text-white hover:text-gray-300 transition-colors duration-200 z-10"
                  }, _cache[25] || (_cache[25] = [
                    _createElementVNode("svg", {
                      class: "w-10 h-10",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 5l7 7-7 7"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})